module.exports = __webpack_public_path__ + "img/searchbar.a37bbc52.jpeg";